<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    :top="top"
    min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="showLabel ? label : ''"
        prepend-inner-icon="mdi-clock-time-four-outline"
        :rules="[...rules]"
        dense
        outlined
        clearable
        hide-details
        @click:clear="cleared"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"></v-text-field>
    </template>
    <v-time-picker
      color="primary"
      attach
      @input="emitVal"
      :value="value"
      full-width
      @change="menu = false"></v-time-picker>
  </v-menu>
</template>

<script>
  /* eslint-disable */
  export default {
    props: {
      value: {
        type: String,
        default: '00:00',
      },
      label: {
        type: String,
        default: () => ' ',
      },
      showLabel: {
        type: Boolean,
        default: () => true,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      top: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        menu: false,
        time: this.value,
      };
    },
    methods: {
      emitVal(val) {
        this.$emit('input', val);
      },
      cleared() {
        this.value = null;
        this.$emit('input', this.value);
      },
    },
  };
</script>

<style></style>
